"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19.815 4.112a.5.5 0 0 1 .172.502l-3.5 15a.5.5 0 0 1-.84.24l-4.178-4.178-2.649 2.208A.5.5 0 0 1 8 17.5v-3.691l-3.724-1.862a.5.5 0 0 1 .013-.9l15-7a.5.5 0 0 1 .526.065M9 13.737v2.695l2.137-1.78 5.387-7.071zm7.093-7.095L5.649 11.515l2.785 1.393zm2.39.019-6.32 8.294 3.555 3.555z"
}), 'Send');
//# sourceMappingURL=index.js.map